<div *ngIf="data" class="summary-container">
  <div
    *ngFor="let item of data"
    class="data-item cursor"
    [matTooltip]="item.tooltip ? item.tooltip : ''"
    matTooltipPosition="above"
    (click)="applayFilter(item.header, item.content)"
  >
      <div class="item-number">
        <div
          *ngFor="let header of item.header | keyvalue"
          [ngStyle]="item.color ?
          {'color' : item.color} :
          {'color' : '#FF9F0A'}"
        >
          {{header.value}}
        </div>
      </div>
      <div class="item-description">
        <div
          *ngFor="let content of item.content | keyvalue"
          [ngStyle]="{'color' : '#424242'}"
        >
          {{content.value}}
        </div>
      </div>
  </div>
</div>


